import { render, staticRenderFns } from "./CuentaUpdate.vue?vue&type=template&id=7312777e&scoped=true"
import script from "./CuentaUpdate.vue?vue&type=script&lang=js"
export * from "./CuentaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312777e",
  null
  
)

export default component.exports